import React, {useState, useContext} from 'react'
import { login } from '../util/session'

const Register = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        login({email, password}).then(res => console.log(res))
    }
    
    return (
        <div>
            <form onSubmit={(e) => handleSubmit(e)}>
                <input type='text' value={email} onChange={(e) => setEmail(e.target.value)}/>
                <input type='text' value={password} onChange={(e) => setPassword(e.target.value)}/>
                <button type='submit'>submit</button>
            </form>
        </div>
    )
}

export default Register